import { render, staticRenderFns } from "./SimilarFeed.vue?vue&type=template&id=4d67e8f0&"
import script from "./SimilarFeed.vue?vue&type=script&lang=js&"
export * from "./SimilarFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports